import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import cancelIcon from '../../assets/images/cross-black.svg';

const CancelButton = props => {
  const { onClick, testId } = props;
  const classes = useStyles();

  return (
    <div data-testid={testId} onClick={onClick} className={classnames(classes.container, classes.icon)}>
      <i className={classnames(classes.icon, classes.cancelIcon)} />
      <span>Cancel</span>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    lineHeight: 1,
    padding: '5px 0',
    textTransform: 'uppercase',
  },
  icon: {
    marginRight: 5,
    marginLeft: 10,
  },
  cancelIcon: {
    backgroundImage: `url(${cancelIcon})`,
    width: 8,
    height: 8,
    display: 'inline-block',
    backgroundSize: 'cover',
  },
});

export { CancelButton };
